'use client';
import { FunctionComponent } from 'react';
import styles from '../styles.module.scss';
import Button from '../../../../../components/Button';

export const LoadMoreButton: FunctionComponent<{ onClick: () => void; hasMore: boolean }> = ({
    onClick,
    hasMore,
}) => {
    if (!hasMore) {
        return null;
    }
    return (
        <div className={styles.loadMoreButtonWrapper}>
            <Button onClick={onClick}>Load more</Button>
        </div>
    );
};
